/** Forbruksnivå mot taket: under 80 %, varsel (80–99 %), eller nådd/over (100 %+). Uten tak: none. */
export type UsageLevel = 'none' | 'normal' | 'warning' | 'over';

export function usageLevel(usagePercent: number | null): UsageLevel {
  if (usagePercent == null) return 'none';
  if (usagePercent >= 100) return 'over';
  if (usagePercent >= 80) return 'warning';
  return 'normal';
}

/** Bredden på forbruksstolpen, klemt til 0–100 %. */
export function usageBarWidth(usagePercent: number | null): string {
  if (usagePercent == null || Number.isNaN(usagePercent)) return '0%';
  return `${Math.min(100, Math.max(0, usagePercent))}%`;
}

/** Valgkoder som har egen tekst i hendelsesloggen. */
const KNOWN_EVENT_VALUES = new Set(['Document', 'Remaining', 'Custom', 'Replace', 'Exclude', 'Link', 'NewOrderLine', 'AI', 'Script']);

/**
 * Oversettelsesnøkkelen (under …values) for en verdi i hendelsesloggen, eller null når verdien vises som den er
 * (antall, bestillingslinje, batch). «Holdt utenfor» lagres som true/false.
 */
export function eventValueKey(eventType: string, value: string | null): string | null {
  if (value == null) return null;
  if (eventType === 'Excluded') return value === 'true' ? 'excludedTrue' : value === 'false' ? 'excludedFalse' : null;
  return KNOWN_EVENT_VALUES.has(value) ? value : null;
}
